<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle" type="grow" small></b-spinner>
                    <strong>No Data Found</strong>
                  </div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(category)="data">
                  {{ data.item.category.name }}
                </template>
                <template #cell(quantities)="data">
                  {{ data.item.quantities.length }}
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button @click="
                      edit(data.item.id, data.item.name, data.item.quantities)
                      " type="button" class="btn-sm btn" variant="primary" v-b-modal.edit>
                      <span v-if="loader"><b-spinner small /></span>
                      <span v-else><i class="mdi mdi-square-edit-outline"></i></span>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="success" title="Success" centered hide-footer size="sm">
      <div class="text-center">
        Stock Levels Reconciled!
      </div>
    </b-modal>

    <b-modal id="success2" title="Success" centered hide-footer size="sm">
      <div class="text-center">
        New Stock Levels Added!
      </div>
    </b-modal>

    <b-modal id="edit-product" centered :title="`Reconcile Quantities for: ${name}`" title-class="font-14" hide-footer
      size="xl">
      <div class="row">
        <a href="" class="col-6" @click.prevent="toggleBar">
          <div class="h4 text-center" :class="{ 'border-3 border-bottom border-primary': stock_mode }">
            Update
          </div>
        </a>
        <a href="" class="col-6" @click.prevent="toggleBar">
          <div class="h4 text-center" :class="{ 'border-3 border-bottom border-primary': !stock_mode }">
            Add
          </div>
        </a>
      </div>
      <br />
      <div class="row text-center">
        <div class="col">Batch</div>
        <!-- <div v-if="stock_mode" class="col">Sold Stock</div> -->
        <div class="col">Current Stock</div>
        <div v-if="stock_mode" class="col">Actual Stock</div>
        <div class="col">Expiry Date</div>
        <div class="col">Buy Price / <small>small unit</small></div>
        <div class="col text-start">Actions</div>
      </div>

      <hr />
      <div v-if="stock_mode">
        <form @submit.prevent="updateSubmit">

          <div class="mb-1 row" v-for="(quantity, index) in quantities" :key="index">
            <div class="col">
              <input placeholder="Batch" readonly class="form-control" v-model="quantity.batch" />
            </div>
            <!-- <div class="col">
              <input readonly type="number" class="form-control" v-model="quantity.sold_quantity" />
            </div> -->
            <div class="col">
              <input readonly type="number" class="form-control" v-model="quantity.quantity" />
            </div>
            <div class="col">
              <input required :readonly="!quantity.qstatus" v-model="quantity.actual_quantity" placeholder="Quantity"
                type="number" class="form-control" />
            </div>
            <div class="col">
              <input required placeholder="Expiry Date" type="date" v-model="quantity.expiry_date"
                class="form-control" />
            </div>
            <div class="col">
              <input required :readonly="!quantity.qstatus" placeholder="Buy Price" type="number"
                v-model="quantity.buying_price" class="form-control" />
            </div>
            <div class="col">
              <button @click.prevent="
                activateBatch(
                  quantity.id, quantity.product
                )
                " title="Activate Batch" v-if="!quantity.active" class="btn btn-success btn-sm"><span
                  v-if="loader5"><b-spinner small></b-spinner></span><span v-else><i
                    class="mdi mdi-check-circle"></i></span></button>
              <button v-else class="btn btn-secondary btn-sm"><small>Activated</small></button>

              <button @click.prevent="remove(index, quantity.batch)" class="ms-3 btn btn-sm" :class="{
                'btn-danger': quantity.qstatus,
                'btn-secondary': !quantity.qstatus,
              }">
                <div v-if="quantity.qstatus">
                  <i class="mdi mdi-trash-can"></i>
                </div>
                <div v-else>Deleted</div>
              </button>
                          </div>
          </div>
          <br>
          <center class="text-danger fs-5">!!! Changing Buy Prices affects Profits !!!</center>
          <hr />
          <div class="row px-5">
            <button type="submit" class="btn btn-primary" :class="{ disabled: loader2 }">
              <span v-if="loader2"><b-spinner small /></span>
              <span v-else>Update Stock</span>
            </button>
          </div>
        </form>
      </div>

      <div v-else>
        <form action="" @submit.prevent="addSubmit">
          <div class="row mb-1" v-for="(entry, index) in add_entries" :key="index">
            <div class="col">
              <input v-model="entry.batch" placeholder="Batch" class="form-control" />
            </div>
            <div class="col">
              <input v-model="entry.current_stock" type="number" placeholder="Quantity" class="form-control" />
            </div>

            <div class="col">
              <input v-model="entry.expiry_date" placeholder="Expiry Date" type="date" class="form-control" />
            </div>
            <div class="col">
              <input v-model="entry.buying_price" placeholder="Buy Price" type="number" class="form-control" />
            </div>
            <div class="col justify-content-center">
              <button @click="deleteEntry(index)" class="ms-3 btn btn-sm btn-danger">
                <i class="mdi mdi-trash-can"></i>
              </button>
            </div>
          </div>
          <div class="text-center">
            <button class="btn btn-primary btn-sm" @click.prevent="addField">
              + Add
            </button>
          </div>
          <hr />
          <div class="row px-5">
            <button type="submit" class="btn btn-primary" :class="{ disabled: loader3 }">
              <span v-if="loader3"><b-spinner small /></span>
              <span v-else>Add Stock</span>
            </button>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal id="delete-batch" centered title="Delete Item Unit" title-class="font-18" hide-footer>
      <form @submit.prevent="deleteRequest(selected_batch)">
        <input v-model="id" type="hidden" />
        Are you sure you want to delete the Batch: <b>{{ batch_number }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-batch')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary">
            <span v-if="loader4"><b-spinner small /></span>
            <span v-else><i class="fas fa-check-circle"></i> YES</span></b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { productMethods, productComputed } from "@/state/helpers";

export default {
  page: {
    title: "Reconcile Stock",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Reconcile Stock",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Reconcile Stock", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      stock_mode: true,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "name", label: "Name", visible: true },
        { key: "category", label: "Category", visible: true },
        { key: "quantities", label: "Batches", visible: true, sortable: true },
        { key: "price", label: "Price", visible: true },
        { key: "addedby", label: "Added by", visible: true },
        { key: "actions", label: "Reconcile", visible: true },
      ],
      id: "",
      name: "",
      category: "",
      unit: "",
      quantities: [],
      price: "",
      newquantity: "0",
      add_entries: [],
      batch_number: '',
      selected_batch: '',

      // Loaders
      loader: '',   // For Getting Reconciling B-Modal
      loader2: '',  // For Updating Stock
      loader3: '',  // For Adding Stock
      loader4: '',  // for confirming deleting
      loader5: '',  // for activating batch
    };
  },
  computed: {
    stockMode() {
      return this.stock_mode;
    },

    ...productComputed,
    List() {
      return this.products.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.products.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.products.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchProducts();
    this.TotalRows = this.products.length;
    this.isBusy = false;
  },
  methods: {
    async updateSubmit() {
      this.loader2 = true
      this.loader = true
      const obj = {
        id: this.id,
        quantities: this.quantities,
      };

      let url = "/update_stock_levels";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.fetchProducts();
          this.$bvModal.hide('edit-product');
          this.$bvModal.show("success");
        }
      });
      await this.fetchProducts();
      this.loader = false
      this.loader2 = false
    },

    async addSubmit() {
      this.loader3 = true
      this.loader = true
      const obj = {
        id: this.id,
        entries: this.add_entries,
      };
      let url = "/add_stock_levels";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {

          this.$bvModal.hide('edit-product');
          this.add_entries = []
          this.$bvModal.show("success2");
        }
      });
      await this.fetchProducts();
      this.loader3 = false
      this.loader = false
    },

    addField() {
      this.add_entries.push({
        batch: "",
        current_quantity: "",
        buying_price: "",
        expiry_date: "",
      });
    },

    deleteEntry(index) {
      this.add_entries.splice(index, 1);
    },

    deleteEntry2(index) {
      this.quantities.splice(index, 1);
    },

    toggleBar() {
      this.stock_mode = !this.stock_mode; // Toggling the value of 'stock_mode'
      return this.stock_mode;
    },
    remove(index, batch_number) {
      this.batch_number = batch_number
      this.selected_batch = index
      this.$bvModal.show('delete-batch')
    },
    deleteRequest(index) {
      this.loader4 = true
      let item = this.quantities[index];
      item.actual_quantity = 0
      item.buying_price = 0
      item.qstatus = !item.qstatus;
      this.$bvModal.hide('delete-batch')
      this.loader4 = false
    },
    ...productMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, name, quantities) {
      this.loader = true
      this.id = id;
      this.name = name;
      this.quantities = quantities;
      this.$bvModal.show("edit-product");
      this.loader = false
    },
    async editProduct() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("newquantity", this.newquantity);
      let url = "/reconcilestock";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchProducts();
          this.$bvModal.hide("edit-product");
          this.name = "";
          this.newquantity = "";
        }
      });
    },

    async activateBatch(id, product) {
      this.loader5 = true
      let obj = {
        quantity: id,
        product: product,
        name: this.name,
      };

      let url = "activate_batch";
      await axios.post(url, obj);
      await this.fetchProducts();
      this.quantities = this.quantities.map((quantity) => {
        if (quantity.id == id) {
          quantity.active = !quantity.active;
        }
        return quantity;
      });
      this.loader5 = false
    },
  },
};
</script>
